import { Button, Drawer, Input, InputNumber, message, Select } from "antd";
import "./dialog.scss";
import React, { useEffect, useState } from "react";
import { DatePicker } from "antd";
import { useHistory } from "react-router-dom";
import moment from "moment";
import TextArea from "antd/lib/input/TextArea";

const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";
const { Option } = Select;

const Dialog = (props) => {
  const { handleClose, open, resultValue } = props;

  const [finalEditedData, setFinalEditedData] = useState();
  const [objecttypes, setobjecttype] = useState([]);
  const [uoms, setuom] = useState([]);
  const [state, setState] = useState({
    fields: {},
    errors: {},
  });

  const query = useHistory().location.search;
  const token = new URLSearchParams(query).get("token");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/types?&token=${token}`)
      .then((res) => res.json())
      .then((response) => {
        setobjecttype(response.data);
      })
      .catch((error) => {
        alert(error.message);
      });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/uoms?&token=${token}`)
      .then((res) => res.json())
      .then((response) => {
        setuom(response.data);
      })
      .catch((error) => {
        alert(error.message);
      });
  }, []);

  useEffect(() => {
    setFinalEditedData(resultValue);
  }, [resultValue]);

  const editUploadData = (event, value) => {
    const field = event.target ? event.target.name : value.name;
    const fvalue = event.target ? event.target.value : value.key;
    setFinalEditedData({
      ...finalEditedData,
      [field]: fvalue,
    });
    let errors = {};
    if (field === "name" && !fvalue) {
      errors[field] = "The title should not be left empty.";
    }
    setState({ errors: errors });
  };

  const editUploadNumericData = (value, typeValue) => {
    setFinalEditedData({ ...finalEditedData, [typeValue]: value ?? 0 });
  };

  const editUploadDateDate = (date, datestring, info) => {
    setFinalEditedData({
      ...finalEditedData,
      startDate: datestring[0],
      endDate: datestring[1],
    });
  };

  const saveObjectiveData = () => {
    fetch(
      `${process.env.REACT_APP_API_URL}/update-objective/${finalEditedData.id}?&token=${token}`,
      {
        method: "POST",
        body: JSON.stringify(finalEditedData),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.data.statusCode === 200) {
          message.info(`Your Objective updated successfully!`);
        } else if (response.data.message) {
          message.error(response.data.message);
        }
      })
      .catch((e) => {
        message.error(`Failed to update the Objective.`);
      });
    setFinalEditedData(finalEditedData);
  };

  const saveKeyresultData = () => {
    fetch(
      `${process.env.REACT_APP_API_URL}/update-keyresult/${finalEditedData.objectiveId}/${finalEditedData.id}?&token=${token}`,
      {
        method: "POST",
        body: JSON.stringify(finalEditedData),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.data.statusCode === 200) {
          message.info(`Your Key Result updated successfully!`);
        } else if (response.data.message) {
          message.error(response.data.message);
        }
      })
      .catch((e) => {
        message.error(`Failed to update the keyresult.`);
      });
    setFinalEditedData(finalEditedData);
  };

  const onClose = () => {
    handleClose && handleClose(false);
    setFinalEditedData(finalEditedData);
    setState({ errors: {} });
  };

  return (
    <>
      {open.type === "header" ? (
        <div>
          {finalEditedData ? (
            <Drawer
              title="Edit Objectives"
              placement="right"
              onClose={onClose}
              open={open}
            >
              <form>
                <div className="dialog-modal-container">
                  <div className="mb-3">
                    <label className="txt-text-1 f-w-500">
                      Name <span className="required-field">*</span>
                    </label>
                    <Input
                      name="name"
                      onChange={editUploadData}
                      value={finalEditedData.name}
                      className="w-100 f-w-500"
                    />
                  </div>
                  <span
                    className={`required-field ${
                      !state?.errors["name"] ? "hide" : ""
                    }`}
                  >
                    {state?.errors["name"]}
                  </span>
                  <div className="mb-3">
                    <label className="txt-text-1 f-w-500">
                      Financial Period <span className="required-field">*</span>
                    </label>
                    <RangePicker
                      className="w-100 f-w-500"
                      defaultValue={[
                        moment(resultValue.startDate, "YYYY-MM-DD"),
                        moment(resultValue.endDate, "YYYY-MM-DD"),
                      ]}
                      format={dateFormat}
                      onChange={editUploadDateDate}
                      allowClear={false}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="txt-text-1 f-w-500">
                      Objective Type <span className="required-field">*</span>
                    </label>
                    <Select
                      showSearch
                      className="w-100 f-w-500"
                      placeholder="Select Type of Objective"
                      onChange={editUploadData}
                      defaultValue={resultValue.objectiveTypeId}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      allowClear={false}
                    >
                      {objecttypes?.map((type) => (
                        <Option
                          key={type.id}
                          value={type.id}
                          name="objectiveTypeId"
                        >
                          {type.name}
                        </Option>
                      ))}
                    </Select>
                  </div>
                  <div className="mb-3">
                    <label className="txt-text-1 f-w-500">Description</label>
                    <TextArea
                      name="description"
                      onChange={editUploadData}
                      value={finalEditedData.description}
                      placeholder="Add additional details about your Objective"
                      autoSize={{ minRows: 3 }}
                      className="w-100 f-w-500"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="txt-text-1 f-w-500">
                      Learnings from the Objective
                    </label>
                    <TextArea
                      name="learning"
                      onChange={editUploadData}
                      value={finalEditedData.learning}
                      placeholder="Typically filled towards the end of OKR period"
                      autoSize={{ minRows: 3 }}
                      className="w-100 f-w-500"
                    />
                  </div>
                </div>
                <div className="modal-dialog-footer d-flex justify-content-end">
                  <Button onClick={onClose} className="me-3" data-telemetry="Close Objective Edit Form">
                    Cancel
                  </Button>
                  <Button
                    onClick={saveObjectiveData}
                    type="primary"
                    disabled={Object.keys(state?.errors).length ? true : false}
                    data-telemetry="Save Objective Edit Form"
                  >
                    Save
                  </Button>
                </div>
              </form>
            </Drawer>
          ) : (
            <></>
          )}
        </div>
      ) : open.type === "keyResult" ? (
        <div>
          {finalEditedData ? (
            <Drawer
              title="Edit Key Result"
              placement="right"
              onClose={onClose}
              open={open}
            >
              <form>
                <div className="dialog-modal-container">
                  <div className="mb-3">
                    <label className="txt-text-1 f-w-500">
                      Name <span className="required-field">*</span>
                    </label>
                    <Input
                      name="name"
                      onChange={editUploadData}
                      value={finalEditedData.name}
                      className="w-100 f-w-500"
                    />
                  </div>
                  <span
                    className={`required-field ${
                      !state?.errors["name"] ? "hide" : ""
                    }`}
                  >
                    {state?.errors["name"]}
                  </span>
                  <div className="mb-3">
                    <label className="txt-text-1 f-w-500">Starting value</label>
                    <InputNumber
                      onChange={(value) =>
                        editUploadNumericData(value, "startingValue")
                      }
                      className="w-100 f-w-500"
                      value={finalEditedData.startingValue || 0}
                      min={0}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="txt-text-1 f-w-500">Target value</label>
                    <InputNumber
                      value={finalEditedData.targetValue || 0}
                      min={0}
                      onChange={(value) =>
                        editUploadNumericData(value, "targetValue")
                      }
                      className="w-100 f-w-500"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="txt-text-1 f-w-500">UOM</label>
                    <Select
                      showSearch
                      className="w-100 f-w-500"
                      placeholder="Select UOM"
                      onChange={editUploadData}
                      allowClear={false}
                      defaultValue={resultValue.uom}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {uoms?.map((uom) => (
                        <Option key={uom} value={uom} name="uom">
                          {uom}
                        </Option>
                      ))}
                    </Select>
                  </div>
                  <div className="mb-3">
                    <label className="txt-text-1 f-w-500">
                      Current Progress
                    </label>
                    <InputNumber
                      onChange={(value) =>
                        editUploadNumericData(value, "currentProgress")
                      }
                      className="w-100 f-w-500"
                      controls="false"
                      name="currentProgress"
                      value={finalEditedData.currentProgress || 0}
                      min={0}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="txt-text-1 f-w-500">
                      Confidence Indicator
                    </label>
                    <InputNumber
                      onChange={(value) =>
                        editUploadNumericData(value, "confidenceIndicator")
                      }
                      className="w-100 f-w-500"
                      controls="false"
                      name="confidenceIndicator"
                      value={finalEditedData.confidenceIndicator || 0}
                      min={0}
                      max={100}
                    />
                  </div>
                </div>
                <div className="modal-dialog-footer d-flex justify-content-end">
                  <Button onClick={onClose} className="me-3" data-telemetry="Close KEy Result Edit Form">
                    Cancel
                  </Button>
                  <Button
                    onClick={saveKeyresultData}
                    type="primary"
                    disabled={Object.keys(state?.errors).length ? true : false}
                    data-telemetry="Save KEy Result Edit Form"
                  >
                    Save
                  </Button>
                </div>
              </form>
            </Drawer>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default Dialog;
